import { cn } from "@teamworksdev/react";
import type { ComponentProps } from "react";
import { forwardRef } from "react";
import type { Maybe } from "~/utils/types";

export const Color = forwardRef<HTMLDivElement, ComponentProps<"div"> & { color: Maybe<string> }>(
  ({ color, className }, ref) => (
    <div className={cn("flex", className)} ref={ref}>
      <div
        className="w-6 h-6 rounded-lg border border-black/10"
        style={{
          backgroundColor: color ?? "transparent",
        }}
      />
    </div>
  ),
);
Color.displayName = "Color";
